import delivery from '@/api/wholesale/delivery-order'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
  invoices: [],
  employees: [],
  location_id: [],

}

export const getters = {

}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  SET_INVOICE_LIST(state, data){
    state.invoices = data
  },
  SET_EMPLOYEE_LIST(state, data){
    state.employees = data
  },
  SET_LOCATION_ID (state, data) {
    state.location_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          location_id: context.state.location_id,
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return delivery.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return delivery.store(data)
  },
  update(context, { id, data }) {
    return delivery.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await delivery.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id){
    return delivery.destroy(id)
  },
  previewPdf(context, id){
    return delivery.previewToPdf(id)
  },
  async getInvoice(context, employeeId){
    let invoice = await delivery.invoice(employeeId)
    context.commit('SET_INVOICE_LIST', invoice.data)
    return Promise.resolve(invoice)
  },
  getInvoiceDetail(context, stockoutId){
    return delivery.invoiceDetail(stockoutId)
  },
  async fetchData(context) {
    let emp = await delivery.employee()
    context.commit('SET_EMPLOYEE_LIST', emp.data)
  },

}
